import { Sparkles, Crown } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface AIChatCreditsInfoProps {
  creditsRemaining: number;
  creditsLimit: number;
  creditsBonus: number;
  isPremium?: boolean;
}

export function AIChatCreditsInfo({ 
  creditsRemaining, 
  creditsLimit, 
  creditsBonus,
  isPremium = false 
}: AIChatCreditsInfoProps) {
  const totalCredits = creditsLimit + creditsBonus;
  const isLow = creditsRemaining <= 2 && creditsRemaining > 0;
  const isExhausted = creditsRemaining === 0;

  return (
    <Badge 
      variant="outline" 
      className={cn(
        "gap-1 text-xs",
        isExhausted && "border-destructive/50 text-destructive",
        isLow && !isExhausted && "border-amber-500/50 text-amber-600",
        !isLow && !isExhausted && "border-primary/50 text-primary"
      )}
    >
      {isPremium ? (
        <Crown className="h-3 w-3" />
      ) : (
        <Sparkles className="h-3 w-3" />
      )}
      {creditsRemaining}/{totalCredits} crédit{totalCredits > 1 ? 's' : ''}
    </Badge>
  );
}
